/* YouTubeの埋め込み */
function onYouTubeIframeAPIReady() {
  document.querySelectorAll("[data-youtube]").forEach((element) => {
    const video_id_list = element.getAttribute("data-youtube").replace(/\s+/g, "");
    const player = new YT.Player(element.id, {
      // videoId にカンマ区切りを渡すと YouTube が読み込まない（src の無い iframe になる）。1 本目だけ渡し、残りは playlist で回す
      videoId: video_id_list.split(",")[0],
      playerVars: {
        playsinline: 1,
        loop: 1,
        listType: "playlist",
        playlist: video_id_list,
        controls: 0,
        autoplay: 1,
        autohide: 1,
        rel: 0,
        showinfo: 0,
        disablekb: 1,
        enablejsapi: 1,
        modestbranding: 1,
        iv_load_policy: 3,
      },
      suggestedQuality: "highres",
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  });
}
// プレーヤーの準備ができたとき
function onPlayerReady(event) {
  event.target.mute();
  event.target.playVideo();
}
// onStateChangeのコールバック関数
function onPlayerStateChange(event) {
  const state = event.data;
  const player = event.target.getIframe();
  const wrapper = player.parentNode;
  wrapper.setAttribute("data-state", state);
}
// iframe_api（YouTube の JS は合わせて約 760KB）は load の 3 秒後に読む。ヒーローのカバー画像＝LCP と帯域を取り合わないように。
// 先に操作（スクロール・タップ・キー）があればその時点で読む。動画の無いページでは読まない
const YOUTUBE_DELAY_AFTER_LOAD = 3000;
const YOUTUBE_INTERACTION_EVENTS = ["scroll", "pointerdown", "keydown", "touchstart"];
let youTubeIframeAPIRequested = false;
function loadYouTubeIframeAPI() {
  if (youTubeIframeAPIRequested) return;
  youTubeIframeAPIRequested = true;
  YOUTUBE_INTERACTION_EVENTS.forEach((type) => window.removeEventListener(type, loadYouTubeIframeAPI));
  const script = document.createElement("script");
  script.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(script);
}
function scheduleYouTubeIframeAPI() {
  setTimeout(loadYouTubeIframeAPI, YOUTUBE_DELAY_AFTER_LOAD);
}
if (document.querySelector("[data-youtube]")) {
  YOUTUBE_INTERACTION_EVENTS.forEach((type) =>
    window.addEventListener(type, loadYouTubeIframeAPI, { once: true, passive: true })
  );
  if (document.readyState === "complete") {
    scheduleYouTubeIframeAPI();
  } else {
    window.addEventListener("load", scheduleYouTubeIframeAPI, { once: true });
  }
}
